import type { SearchFilters } from "./use-search-state";

export function searchFilterSummary(filters: SearchFilters) {
  const musicHasFilters = [
    filters.genre,
    filters.style,
    filters.type,
    filters.format,
    filters.country,
    filters.origin,
    filters.yearFrom,
    filters.yearTo,
    filters.label.length,
    filters.company.length,
  ].some(Boolean);
  const activeFilterCount = [
    filters.genre,
    filters.style,
    filters.type,
    filters.format,
    filters.country,
    filters.origin,
    filters.yearFrom || filters.yearTo,
  ].filter(Boolean).length;
  return {
    musicHasFilters,
    hasFilters: musicHasFilters,
    activeFilterCount: activeFilterCount + filters.label.length + filters.company.length,
  };
}
